import React, { Fragment, useState, useEffect } from 'react';
import { Col, CardBody, Card } from 'reactstrap';
import ListCreditNotes from './ListCreditNotes';

const SearchCreditNotes = ({ }) => {

  const [creditNotes, setCreditNotes] = useState([]);

  const getCreditNotes = async () => {
    await fetch(`${process.env.REACT_APP_PUBLIC_URL}notacredito/listar`, {
      method: 'GET',
      headers: {
        'content-type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    }).then(response => {
      if (response.status != 500 && response.status != 403) {
        return response.json();
      }
      else {
        throw new Error('Error consultando las Notas Crédito');
      }
    }).then(data => {
      setCreditNotes(data);
    }).catch(err => {
      console.log(err);
      setCreditNotes([]);
    });
  }

  useEffect(() => {
    getCreditNotes();
  }, []);


  const CreditsNotesList = () => {
    return (<ListCreditNotes reactTableData={creditNotes} />);
  }

  return (
    <Card>
      <CardBody>
        <CreditsNotesList />
      </CardBody>
    </Card>
  )
}

export default SearchCreditNotes;